import { render } from "./download-contract.template.html?vue&type=template&id=004b5e04&scoped=true"
import script from "./DownloadContract.vue?vue&type=script&lang=ts"
export * from "./DownloadContract.vue?vue&type=script&lang=ts"

import "./DownloadContract.vue?vue&type=style&index=0&id=004b5e04&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-004b5e04"

export default script